export var EmbedKeyStatus;
(function (EmbedKeyStatus) {
    EmbedKeyStatus["ACTIVE"] = "ACTIVE";
    EmbedKeyStatus["REVOKED"] = "REVOKED";
})(EmbedKeyStatus || (EmbedKeyStatus = {}));
//# sourceMappingURL=embed-key-status.enum.js.map